import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';

// This class handles any API calls related to package types.
class PackageType {
  static all(data) {
    const params = buildUrlSearchParams(data);
    return apiCall('GET', 'api/jobs/package_types', params);
  }
}

export default PackageType;
